<template>
  <div>
    <KSRMechanik :kit="kit" :storeId="studioId" :key="service_reload" guestbooking="true" />
  </div>
</template>

<script>
import KSRMechanik from "./KSRMechanik.vue";
export default {
  name: "KSRService",
  components: {KSRMechanik},
  data() {
    return {
      studioId: null,
      kit: "true",
    };
  },
  created() {
    // get studioId from parent
    this.studioId = this.$parent.studioId;

    // get identityToken from session storage if it exists
    const identityToken = sessionStorage.getItem('identityToken');
    if (identityToken) {
      this.kit = identityToken;
    }
  },
  methods: {
    openLoginWindow() {
      this.$parent.openLoginWindow('service');
    },
  }
};
</script>